import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" path="/404" />
      <section className="es-section bg-white">
        <div className="es-container max-w-2xl text-center py-20">
          <div className="text-[10rem] font-bold text-[var(--es-navy)] leading-none" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>404</div>
          <div className="h-1 w-12 bg-[var(--es-accent)] mx-auto mb-6" />
          <h1 className="es-h2 text-[var(--es-navy)]">Page not found.</h1>
          <p className="mt-4 text-[var(--es-text-muted)]">The page you're looking for has been moved or doesn't exist. Let's get you back on track.</p>
          <Link to="/" data-testid="notfound-home-link" className="es-btn-accent mt-8 inline-flex">Return Home <ArrowRight size={18} /></Link>
        </div>
      </section>
    </>
  );
}
